import { useEffect } from "react";
import { useSnackbar } from "notistack";
import type { OptionsObject } from "notistack";
import EventManager from "../EventManager/EventManager";
import { FRAME_EVENT } from "../consts/Frame";
import ToastNotification from "./ToastNotification";

const eventManager = EventManager.getInstance();

/**
 * Prepares Props as expected by the Snackbar Provider
 * @param data
 * @param requestId
 * @param dismissCallback
 * @returns
 */
const getSnackbarPropsForToast = (data, requestId, dismissCallback) => {
    const toastProps = {
        ...data,
        onClose: () => dismissCallback(requestId),
    };
    return {
        key: requestId,
        content: (key) => (
            <ToastNotification id={key} toastProps={toastProps} />
        ),
        onClose: () => eventManager.respondToRequest(requestId, "DISMISSED"),
        anchorOrigin: { horizontal: "right", vertical: "top" },
    };
};

/**
 * Manager Component to Manage global Snackbar
 * @returns
 */
export default function SnackbarManager() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        const unsubscribe = eventManager.subscribe((type, data, requestId) => {
            if (type === FRAME_EVENT.SHOW_TOAST) {
                enqueueSnackbar(
                    "",
                    getSnackbarPropsForToast(
                        data,
                        requestId,
                        closeSnackbar,
                    ) as OptionsObject,
                );
            } else if (type === FRAME_EVENT.RESET) {
                // close all open snackbars, in case of global reset
                closeSnackbar();
            }
        });

        return unsubscribe;
    }, [enqueueSnackbar, closeSnackbar]);

    return null;
}
